import { useI18n } from "@/context/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check, CaretDown } from "@phosphor-icons/react";

export function LanguageSelector({ variant = "light" }) {
  const { lang, setLang, languages, t } = useI18n();
  const current = languages.find((l) => l.code === lang);

  const triggerCls =
    variant === "dark"
      ? "border-zinc-700 bg-zinc-900 text-zinc-100 hover:bg-zinc-800"
      : "border-zinc-300 bg-white text-zinc-800 hover:bg-zinc-100";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector-trigger"
          aria-label={t("nav.language")}
          className={`inline-flex items-center gap-2 border rounded-sm px-3 py-2 text-sm transition-colors duration-150 ${triggerCls}`}
        >
          <Globe size={16} weight="duotone" />
          <span className="font-mono text-[11px] uppercase tracking-wider">{current?.code}</span>
          <span className="hidden sm:inline">{current?.native}</span>
          <CaretDown size={12} weight="bold" className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        data-testid="language-selector-menu"
        className="bg-white border border-zinc-200 shadow-lg rounded-sm w-56 p-1"
      >
        <div className="px-2 py-1.5 text-[10px] font-mono uppercase tracking-widest text-zinc-400 border-b border-zinc-100 mb-1">
          {t("nav.language")}
        </div>
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onSelect={() => setLang(l.code)}
            className="flex items-center gap-3 rounded-sm cursor-pointer text-zinc-800 focus:bg-zinc-100 focus:text-zinc-950"
          >
            <span className="font-mono text-[10px] uppercase tracking-wider border border-zinc-300 bg-zinc-100 text-zinc-600 px-1.5 py-0.5 rounded-sm w-8 text-center">
              {l.code}
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{l.native}</div>
              <div className="text-[11px] text-zinc-400 truncate">{l.label}</div>
            </div>
            {l.code === lang && <Check size={15} weight="bold" className="text-green-600 shrink-0" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
